import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../../../services/language/language.service';

const LOCALE_BY_CURRENCY: Record<string, string> = {
  COP: 'es-CO',
  USD: 'en-US',
  EUR: 'es-ES',
  MXN: 'es-MX'
};

const LANGUAGE_FALLBACK_LOCALES: Record<string, string> = {
  es: 'es-CO',
  en: 'en-US',
  pt: 'pt-BR',
  fr: 'fr-FR',
  ja: 'ja-JP'
};

@Pipe({
  name: 'currencyAmount',
  standalone: false
})
export class CurrencyAmountPipe implements PipeTransform {
  constructor(private readonly languageService: LanguageService) {}

  transform(
    amountInCents: number | null | undefined,
    currency: string | null | undefined,
    options: { showSymbol?: boolean } = {}
  ): string {
    if (amountInCents == null || !Number.isFinite(amountInCents)) {
      return '';
    }
    const safeCurrency = (currency || 'COP').toUpperCase();
    const locale = LOCALE_BY_CURRENCY[safeCurrency]
      || LANGUAGE_FALLBACK_LOCALES[this.languageService.getCurrentLang()]
      || 'es-CO';

    const amount = amountInCents / 100;
    const showSymbol = options.showSymbol !== false;

    try {
      const formatter = new Intl.NumberFormat(locale, {
        style: showSymbol ? 'currency' : 'decimal',
        currency: safeCurrency,
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
      });
      return formatter.format(amount);
    } catch {
      return `${safeCurrency} ${amount.toLocaleString(locale)}`;
    }
  }
}
